import React from 'react'

export default ({ onChange, value, placeholder, lines, marginTop, name }) => <textarea className='textarea' name={name} placeholder={placeholder} onChange={onChange} value={value} rows={lines} style={{ marginTop }} />


// WEBPACK FOOTER //
// ./src/components/Regular/TextArea.js